export default function Hero() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/7d756502059d9dd4e61341bab49cf688.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 w-full flex flex-col items-center justify-center pt-28 pb-16 sm:pt-32 sm:pb-20">
        <button onClick={scrollToTop} className="cursor-pointer mb-8 sm:mb-12">
          <img
            src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/2133e5c400fdc21ca6feb4502d01c8f1.jpeg"
            alt="Forrest Jamison"
            className="h-44 w-44 sm:h-64 sm:w-64 lg:h-80 lg:w-80 rounded-full object-cover shadow-2xl hover:opacity-90 transition-opacity"
          />
        </button>

        <div className="max-w-3xl text-center w-full px-2">
          <h1 className="font-serif text-3xl sm:text-5xl lg:text-7xl text-white leading-tight mb-4 sm:mb-8" style={{ textShadow: '0 2px 20px rgba(0,0,0,0.3)' }}>
            Stories That Transform Perspectives
          </h1>
          <p className="text-base sm:text-xl text-amber-100 mb-8 sm:mb-12 font-light">
            Author of '21 Days' and explorer of the human experience
          </p>

          <div className="flex justify-center mt-6 sm:mt-16">
            <div className="bg-black/60 backdrop-blur-sm rounded-lg p-4 sm:p-6 max-w-md w-full">
              <p className="text-white/90 text-xs sm:text-sm leading-relaxed">
                Published author with Amazon, crafting narratives that challenge and inspire readers worldwide through transformative spiritual journeys
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
